import React from "react";
import { withFocusable } from "../../services/visualLibraryService";
import { withAppState } from "../../state";
import Logo from "../../components/Logo";
import { i18n } from "../../services/i18nService";
import {
  LandingPageStyled,
  BuyBrandsContainer,
  LogoStyled,
  HeadingStyled,
  HeadingStyle,
  StepContainer,
  StepNumber,
  StepText,
  PriceStyled,
  DetailsContainerStyle,
  QrCodeStyle,
  ButtonModalStyled,
  ButtonModelWrapper,
  ImageWrapper,
  PriceContainer,
  TextDetailsStyled
} from "./styles/Styled";
import { Loading } from "../../services/visualLibraryService";
import { getOneTimeAuthToken, getWebPortalURL } from "../../services/tvodService";
import {
  getBuyBrandsInfoObj,
  isBaseContent,
  getBrandsName,
  isBaseContentBrand,
  getBuyBrandsInfoObjChampionsTrophy,
  CHAMPIONS_TROPHY
} from "../../utils/tvodUtils.js";
import { getSdk } from "../../services/sdkService";
import QRCodeReact from "react-qr-code";
import { config } from "../../config/config";
import { withSubtheme } from "../../styles/themes/withSubtheme";
import { base64Encode } from "../../utils/encodingUtil";
import { getLocaleFromLocalCache } from "../../services/localeCacheService.js";
import { getParentAddOn } from "../../utils/mobileLiteUtils.js";
import FreeLogo from "../../components/FreeLogo/FreeLogo.js";

const ButtonModalFocus = withFocusable(ButtonModalStyled);
const finishFocusPath = "buttonFinishBuyBrands";

class BuyBrands extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: (this.props.location && this.props.location.state && this.props.location.state.data) || {},
      loading: false,
      QRCodeURL: "",
      price: "",
      brandsName: "",
      brandsImage: "",
      infoObj: null
    };
    this.pollingFinishTime = new Date(Date.now() + 5 * 60 * 1000); // the next five minutes
    this.onBack = this.onBack.bind(this);
    this.backUserWithUpdatedData = this.backUserWithUpdatedData.bind(this);
  }

  async pollingTime() {
    const { data } = this.state;
    const pollingIntervalTime = config.get().buyAssetOrBrand && config.get().buyAssetOrBrand.pollingTime;
    const addOnNameToBuy = data?.isCTStandalone
      ? CHAMPIONS_TROPHY
      : data?.isChampionsTrophyAddOn
      ? getParentAddOn(data.addonContent)?.name
      : data.addonContent;
    this.timer = setInterval(async () => {
      try {
        const currentDateTime = new Date(Date.now());
        if (currentDateTime > this.pollingFinishTime) {
          clearInterval(this.timer);
          this.backUserWithUpdatedData();
        } else {
          const result = await getSdk().userManager.get({ avoidCache: true, avoidDeepCall: true });
          const purchasedAddOns = result.settings.addons || [];

          let isThisAddOnPurchased = purchasedAddOns.filter(
            addon => addon.name === addOnNameToBuy && addon.status.toLowerCase() === "active"
          );
          isThisAddOnPurchased = isThisAddOnPurchased.length > 0 ? isThisAddOnPurchased[0] : null;

          if (
            (isBaseContentBrand(data.addonContent) || isBaseContent(data.addonContent)) &&
            result.settings.accountStatus.toLowerCase() === "active"
          ) {
            isThisAddOnPurchased = true;
          }

          if (isThisAddOnPurchased) {
            clearInterval(this.timer);
            this.backUserWithUpdatedData();
          }
        }
      } catch (error) {
        console.log(error);
      }
    }, pollingIntervalTime);
  }
  async getQRCode(infoObj) {
    const token = await getOneTimeAuthToken();
    const locale = getLocaleFromLocalCache();

    let urlQueryParams = `token=${token}`;
    // const profile = await getCurrentProfile();
    const profileName = "";
    const profileId = localStorage.getItem("globalUserId");
    urlQueryParams = `${urlQueryParams}&profileId=${profileId}&profileName=${profileName}`;
    const encodedURLPart = base64Encode(urlQueryParams);

    const subscriptionName = infoObj?.CTAddOnData?.isCTStandalone
      ? infoObj?.CTAddOnData?.name
      : infoObj.subscriptionName;
    return `${getWebPortalURL()}/${locale}/settings/tvpayment/choosesubscription/${subscriptionName}?key=${encodedURLPart}`;
  }

  async componentDidMount() {
    this.props.onRef && this.props.onRef(this); // to connect this page to App.js for further use
    this.setState({ loading: true });
    const { data } = this.state;
    const {
      applicationState: { addons }
    } = this.props;
    this.props.resumeNavigation();
    const infoObj = data?.isChampionsTrophyAddOn
      ? getBuyBrandsInfoObjChampionsTrophy(addons, data.addonContent)
      : getBuyBrandsInfoObj(addons, data.addonContent, data.childAddon && data.childAddon);

    const qrCodeURL = await this.getQRCode(infoObj);
    console.log("==> ~ BuyBrands ~ componentDidMount ~ qrCodeURL:", qrCodeURL);

    const brandsName = getBrandsName(
      addons,
      infoObj.action !== "activate" ? infoObj.subscriptionName : data.addonContent
    );

    this.setState({
      infoObj: infoObj,
      QRCodeURL: qrCodeURL,
      loading: false,
      price: infoObj.price,
      brandsImage: brandsName?.configuration.logoDefaultPNG,
      logoCoupledImage: infoObj.logoCoupledImage,
      paymentPlans: infoObj.paymentPlans,
      isMonthlyPlan: infoObj.isMonthlyPlan
    });
    await this.pollingTime();
  }

  componentWillUnmount() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  }

  async enterHandler() {
    await this.onBack();
  }

  async onBack() {
    this.backUserWithUpdatedData();
    return true;
  }

  async backUserWithUpdatedData() {
    this.setState({ loading: true }, async () => {
      const { stateActions, history } = this.props;
      const result = await getSdk().userManager.get({
        avoidCache: true,
        avoidDeepCall: false,
        avoidDeepCallCache: true
      });
      await stateActions.userLoggedIn(result);
      history.goBack();
    });
  }

  render() {
    const { loading, brandsImage, infoObj, paymentPlans, data, isMonthlyPlan } = this.state;

    const championsTrophyPrice = infoObj?.CTAddOnData?.isCTStandalone
      ? infoObj?.price
      : infoObj?.CTAddOnData?.CTPrices?.monthlyPrice;

    return loading ? (
      <Loading overlay />
    ) : (
      <>
        <LogoStyled>
          <FreeLogo />
        </LogoStyled>
        <LandingPageStyled>
          <BuyBrandsContainer>
            <DetailsContainerStyle>
              <HeadingStyle>
                <ImageWrapper
                  src={
                    infoObj?.CTAddOnData?.isCTStandalone
                      ? infoObj?.logoImage
                      : (infoObj && infoObj.logoCoupledImage) || brandsImage
                  }
                  alt="Logo"
                />
                <PriceContainer>
                  <HeadingStyled
                    rank={1}
                    text={
                      infoObj && infoObj.isBilledOnce
                        ? i18n.get("pages.buyBrands.billedOnce")
                        : (paymentPlans && paymentPlans.length === 1) ||
                          infoObj?.action === "switch" ||
                          data?.isChampionsTrophyAddOn
                        ? i18n.get("pages.buyBrands.getItFor")
                        : isMonthlyPlan
                        ? i18n.get("pages.buyBrands.getItFor")
                        : paymentPlans && i18n.get("pages.buyBrands.startFrom")
                    }
                    size="medium"
                  />
                  <PriceStyled
                    rank={1}
                    text={
                      data?.isChampionsTrophyAddOn && championsTrophyPrice
                        ? infoObj?.CTAddOnData?.isCTStandalone
                          ? infoObj?.isRecurringPlan
                            ? i18n.get("pages.buyBrands.oneTimePaymentRecurring", championsTrophyPrice)
                            : i18n.get("pages.buyBrands.oneTimePayment", championsTrophyPrice)
                          : `${i18n.get(
                              "pages.buyBrands.amount",
                              infoObj && infoObj.price,
                              infoObj && infoObj.packageTimeUnit
                            )} ${i18n.get(
                              `pages.layout.activationBanner.parent+addon.additionalIn`,
                              championsTrophyPrice
                            )}`
                        : i18n.get(
                            "pages.buyBrands.amount",
                            infoObj && infoObj.price,
                            infoObj && infoObj.packageTimeUnit
                          )
                    }
                    size="medium"
                  />
                </PriceContainer>
              </HeadingStyle>
              <TextDetailsStyled rank="3" text={i18n.get("pages.buyBrands.heading")} size="medium" />
              <StepContainer>
                <StepNumber>1</StepNumber>
                <StepText rank="3" text={i18n.get("pages.buyBrands.step1")} size="medium" />
              </StepContainer>
              <>
                <StepContainer>
                  <StepNumber>2</StepNumber>
                  <StepText rank="3" text={i18n.get("pages.buyBrands.step2")} size="medium" />
                </StepContainer>
                <StepContainer>
                  <StepNumber>3</StepNumber>
                  <StepText rank="3" text={i18n.get("pages.buyBrands.step3")} size="medium" />
                </StepContainer>
              </>
            </DetailsContainerStyle>
            <QrCodeStyle>
              <QRCodeReact value={this.state.QRCodeURL} size={336} />
            </QrCodeStyle>
          </BuyBrandsContainer>
          <ButtonModelWrapper>
            <ButtonModalFocus
              label={i18n.get("global.cancel").toUpperCase()}
              focusPath={finishFocusPath}
              onEnterPress={() => this.enterHandler()}
              size="medium"
            />
          </ButtonModelWrapper>
        </LandingPageStyled>
      </>
    );
  }
}

const Component = withAppState(withSubtheme(BuyBrands));
Component.defaultFocusPath = finishFocusPath;
export default Component;
